function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M10.953 19.6h.136l-.04-.13a4.3 4.3 0 01-.196-1.222l-.002-.098H5.125c-.98 0-1.775-.795-1.775-1.775V7.1H19.6V5.65h-.003v-.525A3.225 3.225 0 0016.373 1.9H5.125A3.225 3.225 0 001.9 5.125v11.25A3.225 3.225 0 005.125 19.6h5.828zm8.549-10h.2l-.12-.16a3.225 3.225 0 100 3.87l.12-.16h-2.7a1.775 1.775 0 010-3.55h2.5zM20.8 20.826l.205-.176h-4.004c-2.502 0-3.65-1.437-3.65-2.475v-.4c0-.129.064-.313.201-.467.134-.15.277-.208.386-.208h8.048l-.06-.14a2.323 2.323 0 00-.394-.615c-.34-.383-.853-.695-1.47-.695H13.94c-.617 0-1.13.312-1.47.695-.338.38-.568.896-.568 1.43v.4c0 2.118 2.109 3.925 5.1 3.925 1.571 0 2.894-.496 3.799-1.274zm-.737-8.726h.081l.017-.08a3.24 3.24 0 000-1.29l-.017-.08h-3.243V12.1h3.162zm-3.162 7.4v.1h4.864l.027-.058c.19-.406.296-.84.307-1.29l.002-.102h-5.2v1.35zm1.246-14.375v.525H3.35v-.525c0-.98.794-1.775 1.775-1.775h11.248c.98 0 1.775.795 1.775 1.775z"
});

function SvgMyGroupWork(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 28,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgMyGroupWork;